import { RootState } from '@global/store/store';

export const subscriptionSelector = (state: RootState) => state.subscription;
